import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { VrstaKontnogPlana } from './vrsta-kontnog-plana';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vrsta-kontnog-plana-update',
  templateUrl: './vrsta-kontnog-plana-update.component.html'
})
export class VrstaKontnogPlanaUpdateComponent 
extends BaseUpdateComponent<VrstaKontnogPlana> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTAKONTNOGPLANA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'VRSTAKONTNOGPLANA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
